import { z } from 'zod';
import { createEnv } from '../utils';

export const commonNextEnv = () =>
  createEnv({
    server: {},
    client: {
      NEXT_PUBLIC_APP_NAME: z.string().min(1),
      NEXT_PUBLIC_APP_ENV: z.string().min(1).optional().default('development'),
      NEXT_PUBLIC_APP_HOST: z.string().min(1),
      NEXT_PUBLIC_APP_PROTOCOL: z.string().min(1),
      NEXT_PUBLIC_APP_ORIGIN_DOMAIN: z.string().min(1),
      NEXT_PUBLIC_LOG_LEVEL: z.string().min(1).optional().default('info'),
    },
    runtimeEnv: {
      NEXT_PUBLIC_APP_NAME: process.env.NEXT_PUBLIC_APP_NAME,
      NEXT_PUBLIC_APP_ENV: process.env.NEXT_PUBLIC_APP_ENV,
      NEXT_PUBLIC_APP_HOST: process.env.NEXT_PUBLIC_APP_HOST,
      NEXT_PUBLIC_APP_PROTOCOL: process.env.NEXT_PUBLIC_APP_PROTOCOL,
      NEXT_PUBLIC_APP_ORIGIN_DOMAIN: process.env.NEXT_PUBLIC_APP_ORIGIN_DOMAIN,
      NEXT_PUBLIC_LOG_LEVEL: process.env.NEXT_PUBLIC_LOG_LEVEL,
    },
  });
